module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_23-193c017fe0408f63e4ca30cc2c655234.jpg";